import Vue from "vue";
import { baseVueController } from "./baseVueController";
import { util, retailerConfig } from "./index";

//------------------------------------------------------------------------------
// クラス
//------------------------------------------------------------------------------
/**
 * 共通フッターコントローラクラス
 * */
export class footerController extends baseVueController {

    //--------------------------------------------------------------------------
    // 定数
    //--------------------------------------------------------------------------
    private readonly ELEMENT_NAME: string = "#footerController";

    //--------------------------------------------------------------------------
    // 変数
    //--------------------------------------------------------------------------
    /**
     * コピーライト テキスト
     */
    private _copyrightText: string;

    /**
     * サービス利用者規約 キャプション
     */
    private _userRuleCaption: string;

    /**
     * 個人情報等の取り扱いについて キャプション
     */
    private _personalInfoCaption: string;

    /**
     * プライバシーポリシー キャプション
     */
    private _privacyPolicyCaption: string;

    /**
     * ご利用環境について キャプション
     */
    private _useEnvelopCaption: string;

    /**
     * 区切り キャプション
     */
    private _separatorCaption: string;

    /**
     * コピーライト 活性制御
     */
    private _enableCopyright: boolean;

    /**
     * サービス利用者規約 活性制御
     */
    private _enableUserRule: boolean;

    /**
     * 個人情報等の取り扱いについて 活性制御
     */
    private _enablePersonalInfo: boolean;

    /**
     * プライバシーポリシー 活性制御
     */
    private _enablePrivacyPolicy: boolean;

    /**
     * ご利用環境について 活性制御
     */
    private _enableUseEnvelop: boolean;

    ///**
    // * リテーラ別の設定情報 
    // */
    //private _retailerConfig: retailerConfig.retailerConfigEntity;

    //--------------------------------------------------------------------------
    // プロパティ
    //--------------------------------------------------------------------------
    /**
     * リテーラ別設定情報
     */
    public set RetailerConfig(retailerConfig: retailerConfig.retailerConfigEntity) {
        this._retailerConfig = retailerConfig;
    }

    //--------------------------------------------------------------------------
    // コンストラクタ
    //--------------------------------------------------------------------------

    //--------------------------------------------------------------------------
    // メソッド
    //--------------------------------------------------------------------------
    /**
     * 初期化メソッド
     * */
    public init(): void {

        // リテーラ別の初期化処理
        this.initRetailer();

        // vueオブジェクト生成
        this._vue = new Vue({
            el: this.ELEMENT_NAME,
            data: {
                CopyrightText: this._copyrightText,
                UserRuleCaption: this._userRuleCaption,
                PersonalInfoCaption: this._personalInfoCaption,
                PrivacyPolicyCaption: this._privacyPolicyCaption,
                UseEnvelopCaption: this._useEnvelopCaption,
                SeparatorCaption: this._separatorCaption,
                EnableCopyright: this._enableCopyright,
                EnableUserRule: this._enableUserRule,
                EnablePersonalInfo: this._enablePersonalInfo,
                EnablePrivacyPolicy: this._enablePrivacyPolicy,
                EnableUseEnvelop: this._enableUseEnvelop
            },
            methods: {
                linkClickUserRule: (event: JQueryEventObject) => {
                    this.linkClickUserRule(event);
                },
                linkClickPersonalInfo: (event: JQueryEventObject) => {
                    this.linkClickPersonalInfo(event);
                },
                linkClickPrivacyPolicy: (event: JQueryEventObject) => {
                    this.linkClickPrivacyPolicy(event);
                },
                linkClickUseEnvelop: (event: JQueryEventObject) => {
                    this.linkClickUseEnvelop(event);
                }
            }
        });
    }

    /**
     * リテーラ別の初期化処理
     * */
    public initRetailer(): void {

        // ToDo:現行は設定ファイル的(massage.js->RETAILER_CUSTOMIZE)なもので表示情報を切り替えている

        // キャプション設定
        // コピーライト
        this._copyrightText = "COPYRIGHT © FUJIFILM Corporation ALL RIGHTS RESERVED.";
        // サービス利用者規約
        this._userRuleCaption = "サービス利用者規約";
        // 個人情報等の取り扱いについて
        this._personalInfoCaption = "個人情報等の取り扱いについて";
        // プライバシーポリシー
        this._privacyPolicyCaption = "プライバシーポリシー";
        // ご利用環境について
        this._useEnvelopCaption = "ご利用環境について";
        // 区切り
        this._separatorCaption = "|";

        // 活性制御
        // コピーライト
        this._enableCopyright = util.verify.isNotLengthZero(this._retailerConfig.copyright) == true ? true : false;
        // サービス利用者規約
        this._enableUserRule = util.verify.isNotLengthZero(this._retailerConfig.tos) == true ? true : false;
        // 個人情報等の取り扱いについて
        this._enablePersonalInfo = util.verify.isNotLengthZero(this._retailerConfig.personalInfo) == true ? true : false;
        // プライバシーポリシー
        this._enablePrivacyPolicy = util.verify.isNotLengthZero(this._retailerConfig.privacyPolicy) == true ? true : false;
        // ご利用環境について
        this._enableUseEnvelop = util.verify.isNotLengthZero(this._retailerConfig.useEnvelop) == true ? true : false;
                        
    }


    //--------------------------------------------------------------------------
    // イベント
    //--------------------------------------------------------------------------
    /**
    * 前画面遷移ボタン押下メソッド
    * */
    public btnClickReturnFlow(): void {
        // 未使用
    }

    /**
     * 次画面遷移ボタン押下メソッド
     * */
    public btnClickNextFlow(): void {
        // 未使用
    }

    /**
     * サービス利用者規約リンク押下イベント
     * @param event
     */
    private linkClickUserRule(event: JQueryEventObject) {
        console.debug("サービス利用者規約リンク押下イベント");
        util.ui.windowOpen(this._retailerConfig.tos, "", null, null);
    }

    /**
     * 個人情報等の取り扱いについてリンク押下イベント
     * @param event
     */
    private linkClickPersonalInfo(event: JQueryEventObject) {
        console.debug("個人情報等の取り扱いについてリンク押下イベント");
        util.ui.windowOpen(this._retailerConfig.personalInfo, "", null, null);
    }

    /**
     * プライバシーポリシーリンク押下イベント
     * @param event
     */
    private linkClickPrivacyPolicy(event: JQueryEventObject) {
        // ToDo
        console.debug("プライバシーポリシーリンク押下イベント");
        util.ui.windowOpen(this._retailerConfig.privacyPolicy, "", null, null);
    }

    /**
     * ご利用環境についてリンク押下イベント
     * @param event
     */
    private linkClickUseEnvelop(event: JQueryEventObject) {
        console.debug("ご利用環境についてリンク押下イベント");
        util.ui.windowOpen(this._retailerConfig.useEnvelop, "", null, null);
    }

}


